import { Skeleton, Box } from '@mui/material';

const TherapistListSkeletonCard = () => (
  <>
    <Box flex={1}>
      <Skeleton
        variant="rectangular"
        width="100%"
        height={120}
        style={{ borderRadius: '5px', marginTop: '20px', marginBottom: '20px' }}
      />
    </Box>
    {Array(6)
      .fill(0)
      .map((_, i) => (
        <div
          className="therapist-div margin-top--md"
          key={i}
          style={{ maxWidth: '900px', margin: 'auto' }}>
          <Box padding={2}>
            <Skeleton variant="rectangular" width="100%" height={30} />
            <Box display="flex" marginTop={2}>
              <Skeleton variant="circular" width={100} height={100} />
              <Box marginLeft={2} flex={1}>
                <Skeleton width="90%" height={25} />
                <Skeleton width="90%" height={25} />
                <Skeleton width="90%" height={25} />
                <Skeleton width="90%" height={25} />
              </Box>
            </Box>
          </Box>
        </div>
      ))}
  </>
);

export default TherapistListSkeletonCard;
